module.exports = __webpack_public_path__ + "static/media/course-arrow-down.56442198.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Courses/course-arrow-down.svg
// module id = 124
// module chunks = 0